import { render, staticRenderFns } from "./_product_group_slug.vue?vue&type=template&id=34809e6c"
import script from "./_product_group_slug.vue?vue&type=script&lang=js"
export * from "./_product_group_slug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports